import React, {useEffect, useState, useRef} from 'react';
import './index.scss';
import {useAppDispatch, useAppSelector} from "../../states/hooks";
import {useNavigate} from "react-router-dom";
import {MapContainer, Marker, Polyline, Popup, TileLayer, useMap, Tooltip} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L, {divIcon, LineCapShape} from 'leaflet';
import restApi from "../../api/restApi";
import KeyboardBackspaceTwoToneIcon from "@mui/icons-material/KeyboardBackspaceTwoTone";
import ModeOfTravelTwoToneIcon from '@mui/icons-material/ModeOfTravelTwoTone';
import LayersTwoToneIcon from '@mui/icons-material/LayersTwoTone';
import {Button, ButtonGroup, Checkbox, DialogActions, FormControlLabel, Menu, MenuItem, TextField} from "@mui/material";
import {LatLngExpression} from "leaflet";
import helpers from "../../utils/helpers";
import LocationSearchingIcon from '@mui/icons-material/LocationSearching';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import imageIconCar from '../../assets/images/icon-car.png';
import imageIconCar2 from '../../assets/images/icon-car-2.png';
import imageIconPoint from '../../assets/images/icon-point.png';
import imageIconStopMarker from '../../assets/images/icon-stop-marker.png';
import LoadingOver from "../../components/LoadingOver";
import Dialog from "@mui/material/Dialog/Dialog";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { Slider } from '@mui/material';
import {renderToStaticMarkup} from "react-dom/server";
import NavigationTwoToneIcon from '@mui/icons-material/NavigationTwoTone';
import RestoreTwoToneIcon from '@mui/icons-material/RestoreTwoTone';
import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone';
import simplify from 'simplify-js';
import axios from "axios";
import CheckTwoToneIcon from "@mui/icons-material/CheckTwoTone";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import MenuIcon from '@mui/icons-material/Menu';
import InputBase from '@mui/material/InputBase';
import {trackingState} from "../../states/trackingState";

//**********************************************************

let currentPositions: any = [];
let currentPositionTimer: any = 0;
let routePositionTimer: any = 0;
let routePositionIndex: number = 0;
let iconDirectionSign: any = [];
let iconDirectionCar: any = [];
let batteryLevel: string = '';
let ignition: number = -1;

enum mapLayers
{
    // map1 = 'http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    // map1 = 'https://core-sat.maps.yandex.net/tiles?l=sat&x={x}&y={y}&z={z}',
    // map2 = 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
    // map2 = 'https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
    // map2 = 'https://b.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png',
    map1 = 'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
    map2 = 'https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
    map3 = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    map4 = 'https://b.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png',
}

//**********************************************************

function Index(props: any)
{
    const navigate = useNavigate();
    const dispatch = useAppDispatch()
    const userState = useAppSelector(state => state.userState);
    const _trackingState = useAppSelector(state => state.trackingState);
    const [devices, setDevices] = useState<any>(null);
    const [currentDevice, setCurrentDevice] = useState<any>(null);
    const [routePositions, setRoutePositions] = useState<any>([]);
    const [routePositionsPlay, setRoutePositionsPlay] = useState<any>([]);
    const [routePositionsStop, setRoutePositionsStop] = useState<any>([]);
    const [currentPosition, setCurrentPosition] = useState<any>([]);
    const [mapCenterPosition, setMapCenterPosition] = useState<LatLngExpression>({lat: 35.7129854, lng: 51.3607368});
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const openDeviceItems = Boolean(anchorEl);
    const [anchorElFilter, setAnchorElFilter] = React.useState<null | HTMLElement>(null);
    const openFilter = Boolean(anchorElFilter);
    const [anchorElSetting, setAnchorElSetting] = React.useState<null | HTMLElement>(null);
    const openSetting = Boolean(anchorElSetting);
    const [anchorElLayer, setAnchorElLayer] = React.useState<null | HTMLElement>(null);
    const openLayer = Boolean(anchorElLayer);
    const [showStopPoint, setShowStopPoint] = useState<boolean>(false);
    const [showDirectionSign, setShowDirectionSign] = useState<boolean>(false);
    const [isPlay, setIsPlay] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [positionDatetime1, setPositionDatetime1] = useState<string>("");
    const [positionDatetime2, setPositionDatetime2] = useState<string>("");
    const [maxSpeed, setMaxSpeed] = useState<string>("");
    const [totalDistance, setTotalDistance] = useState<number>(0);

    const [filterDate1, setFilterDate1] = useState("");
    const [filterDate2, setFilterDate2] = useState("");
    const [filterTime1, setFilterTime1] = useState("");
    const [filterTime2, setFilterTime2] = useState("");
    const [dialogFilterDateIsOpen, setDialogFilterDateIsOpen] = useState(false);

    const [openPopup, setOpenPopup] = useState(true);
    const [mapLayer, setMapLayer] = useState(mapLayers.map3);
    const [routePositionsPlayIndex, setRoutePositionsPlayIndex] = useState(0);

    const [positionTolerance, setPositionTolerance] = useState<any>(0.00004);

    // icons
    const iconCar = L.icon({iconUrl: imageIconCar2, className: "icon-car"});
    const iconPoint = L.icon({iconUrl: imageIconPoint, className: "icon-point", iconSize: new L.Point(5, 5)});
    const iconStopMarker = L.icon({iconUrl: imageIconStopMarker, className: "icon-stop-marker"});

    //
    useEffect
    (
        () =>
        {
            currentPositions = [];
            currentPositionTimer = 0;
            routePositionTimer = 0;
            routePositionIndex = 0;
            iconDirectionSign = [];
            iconDirectionCar = [];
            batteryLevel = '';
            ignition = -1;

            const iconCarMarkup = renderToStaticMarkup(<img src={imageIconCar2} alt="" className="icon-car" />);
            for(let i = 0; i <= 360; i++)
            {
                iconDirectionCar[i] = L.divIcon({html: iconCarMarkup, className: "icon-direction-car t" + i});
            }

            const iconMarkup = renderToStaticMarkup(<NavigationTwoToneIcon className="icon-car" />);
            for(let i = 0; i <= 360; i++)
            {
                iconDirectionSign[i] = L.divIcon({html: iconMarkup, className: "icon-direction-sign t" + i});
            }

            getDevices();
        },
        []
    );

    // get devices from server
    const getDevices = () =>
    {
        setIsLoading(true);

        //
        restApi.get('/devices', null, userState).then
        (
            async function(response)
            {
                if(response != null && response.length > 0)
                {
                    setDevices(response);
                    setCurrentDevice(response[response.length - 1]);
                }
                else
                {
                    // show error
                }
            }
        ).catch
        (
            function(error)
            {
            }
        ).finally
        (
            function()
            {
                setIsLoading(false);
            }
        );
    };

    // get current position
    const getCurrentPosition = (deviceId: number, showLoading: boolean = true) =>
    {
        setIsLoading(showLoading);

        let dateToday1 = new Date();
        let dateToday2 = new Date();
        dateToday1.setMinutes(dateToday1.getMinutes() - 60);
        dateToday2.setMinutes(dateToday2.getMinutes() - dateToday2.getTimezoneOffset());
        dateToday2.setUTCHours(23,59,59,59);

        //
        restApi.get('/positions', {deviceId: deviceId}, userState).then
        // restApi.get('/positions', {deviceId: deviceId, from: dateToday1.toISOString().slice(0, -5) + 'Z', to: dateToday2.toISOString().slice(0, -5) + 'Z'}, userState).then
        (
            async function(response)
            {
                if(response != null && response.length > 0)
                {
                    const cpLen = 15;
                    /*
                    const cp = currentPosition;
                    cp[cp.length] = response[0];
                    let positions = (cp.length > cpLen) ? cp.slice(cp.length - cpLen, cp.length) : cp;
                    let position = positions[positions.length - 1];

                    setCurrentPosition(positions);
                    setMapCenterPosition({lat: position.latitude, lng: position.longitude});
                    */

                    if(currentPositions == null || currentPositions.length === 0 || currentPositions[currentPositions.length - 1].id !== response[0].id)
                    {
                        currentPositions[currentPositions.length] = response[0];

                        let positions = (currentPositions.length > cpLen) ? currentPositions.slice(currentPositions.length - cpLen, currentPositions.length) : currentPositions;
                        let position = positions[positions.length - 1];

                        setCurrentPosition(positions);
                        setMapCenterPosition({lat: position.latitude, lng: position.longitude});
                    }
                }
                else
                {
                    // show error
                }
            }
        ).catch
        (
            function(error)
            {
            }
        ).finally
        (
            function()
            {
                setIsLoading(false);
            }
        );
    };

    // get positions
    const getPositions = (datetime1:string, datetime2:string, _showStopPoint:boolean = showStopPoint, _positionTolerance:number = positionTolerance) =>
    {
        if(datetime1 === '' && datetime1 === '')
        {
            getCurrentPosition(currentDevice.id, true);

            return;
        }

        setIsLoading(true);

        setPositionDatetime1(datetime1);
        setPositionDatetime2(datetime2);

        //
        restApi.get('/positions', {deviceId: currentDevice.id, from: datetime1, to: datetime2}, userState).then
        (
            async function(response)
            {
                if(response != null && response.length > 0)
                {
                    let optimizedPoints = response;

                    // optimization
                    if(_positionTolerance > 0)
                    {
                        const pointsForSimplify = response.map((point: { latitude: any; longitude: any; }) => ({ x: point.latitude, y: point.longitude }));
                        const simplifiedPoints = simplify(pointsForSimplify, _positionTolerance, true);

                        optimizedPoints = simplifiedPoints.map
                        (
                            simplifiedPoint =>
                            {
                                const originalPoint = response.find((point: { latitude: any; longitude: any; }) => point.latitude === simplifiedPoint.x && point.longitude === simplifiedPoint.y);

                                return { ...simplifiedPoint, ...originalPoint };
                            }
                        );
                    }

                    //
                    let rp = [];
                    let _routePositionsStop = [];
                    let stopPoint_1 = null;
                    let stopPoint_2 = null;
                    for (let i = 0; i < optimizedPoints.length; i++)
                    {
                        if(_showStopPoint || optimizedPoints[i].speed > 0)
                        {
                            rp[rp.length] = optimizedPoints[i];
                        }
                    }

                    // stop point
                    for (let i = 0; i < response.length; i++)
                    {
                        if(response[i].speed <= 7)
                        {
                            if(stopPoint_1 === null)
                            {
                                stopPoint_1 = response[i];
                            }
                            else if(((new Date(response[i].fixTime).getTime() - new Date(stopPoint_1.fixTime).getTime()) / 1000) > 180)
                            {
                                stopPoint_2 = response[i];
                            }
                        }
                        else
                        {
                            if(stopPoint_1 != null && stopPoint_2 != null)
                            {
                                const stopTime = Math.floor((new Date(stopPoint_2.fixTime).getTime() - new Date(stopPoint_1.fixTime).getTime()) / (1000 * 60));
                                _routePositionsStop[_routePositionsStop.length] = {'latitude': stopPoint_1.latitude, 'longitude': stopPoint_1.longitude, 'stopTime': stopTime, 'timeStart': helpers.initTimeOfDateTime(stopPoint_1.fixTime), 'timeEnd': helpers.initTimeOfDateTime(stopPoint_2.fixTime)};
                            }

                            stopPoint_1 = null;
                            stopPoint_2 = null;
                        }
                    }

                    //
                    setTotalDistance(helpers.calculateTotalDistance(response));
                    setRoutePositions(rp);
                    setRoutePositionsPlay([]);
                    setRoutePositionsStop(_routePositionsStop);
                    setMapCenterPosition({lat: rp[0].latitude, lng: rp[0].longitude});

                    /*
                    let rp = [];

                    for (let i = 0; i < response.length; i++)
                    {
                        if(showStopPoint || response[i].speed > 0) rp[rp.length] = response[i];
                    }

                    setRoutePositions(rp);
                    setRoutePositionsPlay([]);
                    setMapCenterPosition({lat: rp[0].latitude, lng: rp[0].longitude});
                    */
                }
                else
                {
                    // show error
                }
            }
        ).catch
        (
            function(error)
            {
            }
        ).finally
        (
            function()
            {
                setIsLoading(false);
            }
        );
    };

    // handle device items
    const handleOpenDeviceItems = (event: React.MouseEvent<HTMLElement>) =>
    {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseDeviceItems = () =>
    {
        setAnchorEl(null);
    };

    const handleDeviceChange = (item:any) =>
    {
        handleCloseDeviceItems();
        setCurrentDevice(item);
        setCurrentPosition([]);
        currentPositions = [];

        if(currentPositionTimer > 0)
        {
            clearInterval(currentPositionTimer);
            currentPositionTimer = 0;
        }
    };

    // handle filter
    const handleOpenFilter = (event: React.MouseEvent<HTMLElement>) =>
    {
        setAnchorElFilter(event.currentTarget);
    };

    const handleCloseFilter = () =>
    {
        setAnchorElFilter(null);
    };

    const handleOpenSetting = (event: React.MouseEvent<HTMLElement>) =>
    {
        setAnchorElSetting(event.currentTarget);
    };

    const handleCloseSetting = () =>
    {
        setAnchorElSetting(null);
        resetMapPositions();
        getPositions(positionDatetime1, positionDatetime2);
    };

    const resetMapPositions = () =>
    {
        handleCloseFilter();
        //handleCloseSetting();

        //
        setCurrentPosition([]);
        setRoutePositions(null);
        setRoutePositionsStop(null);
        setRoutePositionsPlay(null);
        currentPositions = [];

        if(currentPositionTimer > 0)
        {
            clearInterval(currentPositionTimer);
            currentPositionTimer = 0;
        }
        if(routePositionTimer > 0)
        {
            clearInterval(routePositionTimer);
            routePositionTimer = 0;
        }
    }

    const handleFilterChange = (index:number) =>
    {
        resetMapPositions();

        //
        switch (index)
        {
            case 15:
            {
                let dateNow = new Date();
                let dateBefore15Min = new Date();

                dateBefore15Min.setMinutes(dateNow.getMinutes() - 15);

                getPositions(dateBefore15Min.toISOString().slice(0, -5) + 'Z', dateNow.toISOString().slice(0, -5) + 'Z');

                break;
            }

            case 30:
            {
                let dateNow = new Date();
                let dateBefore30Min = new Date();

                dateBefore30Min.setMinutes(dateNow.getMinutes() - 30);

                getPositions(dateBefore30Min.toISOString().slice(0, -5) + 'Z', dateNow.toISOString().slice(0, -5) + 'Z');

                break;
            }

            case 60:
            {
                let dateNow = new Date();
                let dateBefore1Hour = new Date();

                dateBefore1Hour.setMinutes(dateNow.getMinutes() - 60);

                getPositions(dateBefore1Hour.toISOString().slice(0, -5) + 'Z', dateNow.toISOString().slice(0, -5) + 'Z');

                break;
            }

            case 120:
            {
                let dateNow = new Date();
                let dateBefore2Hours = new Date();

                dateBefore2Hours.setMinutes(dateNow.getMinutes() - 120);

                getPositions(dateBefore2Hours.toISOString().slice(0, -5) + 'Z', dateNow.toISOString().slice(0, -5) + 'Z');

                break;
            }

            case 24:
            {
                let dateNow = new Date();
                let dateBefore24Hours = new Date();

                dateBefore24Hours.setMinutes(dateNow.getMinutes() - 1440);

                getPositions(dateBefore24Hours.toISOString().slice(0, -5) + 'Z', dateNow.toISOString().slice(0, -5) + 'Z');

                break;
            }

            case 1:
            {
                let dateToday1 = new Date();
                let dateToday2 = new Date();

                dateToday1.setMinutes(dateToday1.getMinutes() - dateToday1.getTimezoneOffset());
                dateToday1.setUTCHours(0,0,0,0);
                dateToday1.setMinutes(dateToday1.getMinutes() - (dateToday1.getTimezoneOffset() * -1));

                dateToday2.setMinutes(dateToday2.getMinutes() - dateToday2.getTimezoneOffset());
                dateToday2.setUTCHours(23,59,59,59);
                dateToday2.setMinutes(dateToday2.getMinutes() - (dateToday2.getTimezoneOffset() * -1));

                getPositions(dateToday1.toISOString().slice(0, -5) + 'Z', dateToday2.toISOString().slice(0, -5) + 'Z');

                break;
            }

            case 2:
            {
                let dateYesterday1 = new Date();
                let dateYesterday2 = new Date();

                dateYesterday1.setDate(dateYesterday1.getDate() - 1);
                dateYesterday1.setMinutes(dateYesterday1.getMinutes() - dateYesterday1.getTimezoneOffset());
                dateYesterday1.setUTCHours(0,0,0,0);
                dateYesterday1.setMinutes(dateYesterday1.getMinutes() - (dateYesterday1.getTimezoneOffset() * -1));

                dateYesterday2.setDate(dateYesterday2.getDate() - 1);
                dateYesterday2.setMinutes(dateYesterday2.getMinutes() - dateYesterday2.getTimezoneOffset());
                dateYesterday2.setUTCHours(23,59,59,59);
                dateYesterday2.setMinutes(dateYesterday2.getMinutes() - (dateYesterday1.getTimezoneOffset() * -1));

                getPositions(dateYesterday1.toISOString().slice(0, -5) + 'Z', dateYesterday2.toISOString().slice(0, -5) + 'Z');

                break;
            }

            case 3:
            {
                setDialogFilterDateIsOpen(true);

                break;
            }
        }
    };

    // handle layer
    const handleOpenLayer = (event: React.MouseEvent<HTMLElement>) =>
    {
        setAnchorElLayer(event.currentTarget);
    };

    const handleCloseLayer = () =>
    {
        setAnchorElLayer(null);
    };

    const handleLayerChange = (index:number) =>
    {
        let mpl = mapLayers.map2;
        switch (index)
        {
            case 1: mpl = mapLayers.map1; break;
            case 2: mpl = mapLayers.map2; break;
            case 3: mpl = mapLayers.map3; break;
            case 4: mpl = mapLayers.map4; break;
        }
        handleCloseLayer();
        setMapLayer(mpl/*index === 1 ? mapLayers.map1 : mapLayers.map2*/);
    };

    //
    const handlePlay = (currentIndex: number = 0) =>
    {
        let cp: any = [];
        let p = routePositions;
        let p2 = (routePositionsPlay != null && routePositionsPlay.length == routePositions.length) ? null : routePositionsPlay;
        routePositionIndex = currentIndex > 0 ? currentIndex : (p2 != null && p2.length > 0 ? p2.length : 0);

        if(routePositionIndex === 0) setOpenPopup(false);
        setIsPlay(true);
        // dispatch(trackingState.actions.save({isPlay: true}));
        setCurrentPosition([]);
        currentPositions = [];
        batteryLevel = '';
        ignition = -1;

        const initPlay = () =>
        {
            cp = p.slice(0, routePositionIndex);
            setRoutePositionsPlay(cp);

            if(routePositionIndex > 0) setMapCenterPosition({lat: cp[cp.length - 1].latitude, lng: cp[cp.length - 1].longitude});

            if(routePositionIndex > p.length - 1)
            {
                clearInterval(routePositionTimer);
                routePositionTimer = 0;
                routePositionIndex = 0;

                setIsPlay(false);
                // dispatch(trackingState.actions.save({isPlay: false}));
            }

            routePositionIndex += 1;
            setRoutePositionsPlayIndex(routePositionIndex);
        }

        initPlay();
        routePositionTimer = setInterval(initPlay, 1000);
    }

    const handlePause = () =>
    {
        if(routePositionTimer > 0)
        {
            clearInterval(routePositionTimer);
            routePositionTimer = 0;
        }

        setIsPlay(false);
        // dispatch(trackingState.actions.save({isPlay: false}));
    }

    function handleOpenPopup(e:any)
    {
        if(openPopup) e.target.openPopup();
    }

    function handleHidePopup()
    {
        setOpenPopup(false);
    }

    function handleShowPopup()
    {
        setOpenPopup(true);
    }

    // map slide
    const handleMapSlideChange = (e: any, v: number | number[]) =>
    {
        if (typeof v === 'number')
        {
            handlePause();
            handlePlay(v);
        }
    }

    // current position
    useEffect
    (
        () =>
        {
            if(currentPositionTimer > 0)
            {
                clearInterval(currentPositionTimer);
                currentPositionTimer = 0;
            }
            if(currentDevice != null) handleCurrentPosition();
        },
        [currentDevice]
    );

    useEffect
    (
        () =>
        {
            return () =>
            {
                if(currentPositionTimer)
                {
                    clearInterval(currentPositionTimer);
                    currentPositionTimer = null;
                }
            };
        },
        []
    );

    const handleCurrentPosition = () =>
    {
        if(!(currentPositionTimer > 0))
        {
            setPositionDatetime1("");
            setPositionDatetime2("");

            runCurrentPosition(true);

            currentPositionTimer = setInterval
            (
                function ()
                {
                    runCurrentPosition(false);
                },
                15000
            );
        }
    }

    const runCurrentPosition = (showLoading: boolean) =>
    {
        setRoutePositions(null);
        setRoutePositionsStop(null);
        setRoutePositionsPlay(null);

        if(currentDevice != null) getCurrentPosition(currentDevice.id, showLoading);

        if(routePositionTimer > 0)
        {
            clearInterval(routePositionTimer);
            routePositionTimer = 0;
        }
    }

    // filter date
    const handleDialogFilterDateClose = () =>
    {
        setDialogFilterDateIsOpen(false);
    }

    const handleDialogFilterDate = () =>
    {
        if(filterDate1 !== "" && filterDate2 !== "" && filterTime1 !== "" && filterTime2 !== "")
        {
            /*
            let fd1 = new Date(filterDate1);
            let ft1 = new Date(filterTime1);
            let fdt1 = fd1.getFullYear() + "-" + helpers.inNumber(fd1.getMonth() + 1) + "-" + helpers.inNumber(fd1.getDate()) + "T" + helpers.inNumber(ft1.getHours()) + ":" + helpers.inNumber(ft1.getMinutes()) + ":" + helpers.inNumber(ft1.getSeconds()) + "Z";

            let fd2 = new Date(filterDate2);
            let ft2 = new Date(filterTime2);
            let fdt2 = fd2.getFullYear() + "-" + helpers.inNumber(fd2.getMonth() + 1) + "-" + helpers.inNumber(fd2.getDate()) + "T" + helpers.inNumber(ft2.getHours()) + ":" + helpers.inNumber(ft2.getMinutes()) + ":" + helpers.inNumber(ft2.getSeconds()) + "Z";

            getPositions(fdt1, fdt2);
            setDialogFilterDateIsOpen(false);
            */

            let fd1 = new Date(filterDate1);
            let ft1 = new Date(filterTime1);
            let fdt1 = new Date(fd1.getFullYear(), fd1.getMonth(), fd1.getDate(), ft1.getHours(), ft1.getMinutes());

            let fd2 = new Date(filterDate2);
            let ft2 = new Date(filterTime2);
            let fdt2 = new Date(fd2.getFullYear(), fd2.getMonth(), fd2.getDate(), ft2.getHours(), ft2.getMinutes());

            getPositions(fdt1.toISOString().slice(0, -5) + 'Z', fdt2.toISOString().slice(0, -5) + 'Z');
            setDialogFilterDateIsOpen(false);
        }

        setFilterDate1("");
        setFilterDate2("");
        setFilterTime1("");
        setFilterTime2("");
    }

    // back
    const handleBack = () =>
    {
        navigate(-1);
    }

    // back
    // const handleTolerance = (tolerance: number) =>
    // {
    //     resetMapPositions();
    //     setPositionTolerance(tolerance);
    //     getPositions(positionDatetime1, positionDatetime2, showStopPoint, tolerance);
    // }

    // car information
    const carInformation = (position: any) =>
    {
        batteryLevel = (position.attributes.batteryLevel !== undefined) ? position.attributes.batteryLevel : batteryLevel;
        ignition = (position.attributes.ignition !== undefined) ? (position.attributes.ignition ? 1 : 0) : ignition;

        let ele = [];
        ele.push(<div className="car-popup-item"><span className="title">سرعت</span><span className="value">{helpers.initSpeed(position.speed)} km</span></div>);
        ele.push(<div className="car-popup-item"><span className="title">زمان</span><span className="value">{helpers.initDateTime(position.fixTime)}</span></div>);
        if(position.attributes.charge !== undefined) ele.push(<div className="car-popup-item"><span className="title">شارژ</span><span className="value">{position.attributes.charge ? 'بله' : 'خیر'}</span></div>);
        if(position.attributes.blocked !== undefined) ele.push(<div className="car-popup-item"><span className="title">بلوکه</span><span className="value">{position.attributes.blocked ? 'بله' : 'خیر'}</span></div>);
        // if(position.attributes.batteryLevel !== undefined) ele.push(<div className="car-popup-item"><span className="title">باطری</span><span className="value">{position.attributes.batteryLevel}%</span></div>);
        if(batteryLevel !== '') ele.push(<div className="car-popup-item"><span className="title">باطری</span><span className="value">{batteryLevel}%</span></div>);
        if(position.attributes.motion !== undefined) ele.push(<div className="car-popup-item"><span className="title">حرکت</span><span className="value">{position.attributes.motion ? 'بله' : 'خیر'}</span></div>);
        // if(position.attributes.ignition !== undefined) ele.push(<div className="car-popup-item"><span className="title">روشن</span><span className="value">{position.attributes.ignition ? 'بله' : 'خیر'}</span></div>);
        if(ignition !== -1) ele.push(<div className="car-popup-item"><span className="title">روشن</span><span className="value">{ignition === 1 ? 'بله' : 'خیر'}</span></div>);
        if(position.attributes.door !== undefined) ele.push(<div className="car-popup-item"><span className="title">درب</span><span className="value">{position.attributes.door ? 'باز' : 'بسته'}</span></div>);
        //if(position.attributes.fuel1 !== undefined) ele.push(<div className="car-popup-item"><span className="title">دما</span><span className="value">{position.attributes.fuel1}</span></div>);

        return ele;
    }

    //--------------------
    return (<div className="page-tracking">
            {/* header */}
            <header>
                {devices != null && devices.length > 0 ? <div className="current-device t2">
                        <span className="title">خودرو:</span>
                        <span className="car-name">{currentDevice.name}</span>
                            <div className="btn-change">
                                <Button className="btn-title" onClick={handleOpenDeviceItems}>(تغییر خودرو)</Button>
                                <Menu anchorEl={anchorEl} open={openDeviceItems} onClose={handleCloseDeviceItems} className="device-menu-items">
                                    {
                                        devices.map
                                        (
                                            (item: any, index: number) =>
                                            {
                                                return <MenuItem className="item" onClick={() => handleDeviceChange(item)} key={"dmi" + index}>{item.name}</MenuItem>
                                            }
                                        )
                                    }
                                </Menu>
                            </div>
                        </div>
                        :
                        <div></div>
                }

                <div className="btn-box">
                    <button type="button" className="btn-layer" onClick={handleOpenLayer}><LayersTwoToneIcon/></button>
                    <Menu anchorEl={anchorElLayer} open={openLayer} onClose={handleCloseLayer} className="filter-menu-items">
                        <MenuItem className="item" onClick={() => handleLayerChange(1)}>نقشه ماهواره</MenuItem>
                        <MenuItem className="item" onClick={() => handleLayerChange(2)}>نقشه عادی 1</MenuItem>
                        <MenuItem className="item" onClick={() => handleLayerChange(3)}>نقشه عادی 2</MenuItem>
                        <MenuItem className="item" onClick={() => handleLayerChange(4)}>نقشه عادی 3</MenuItem>
                    </Menu>

                    <button type="button" className="btn-current-position" onClick={handleCurrentPosition}><LocationSearchingIcon/></button>

                    <button type="button" className="btn-filter" onClick={handleOpenSetting}><SettingsTwoToneIcon/></button>
                    {/*<Menu anchorEl={anchorElSetting} open={openSetting} onClose={handleCloseSetting} className="filter-menu-items">*/}
                    {/*    <MenuItem className="item">*/}
                    {/*        <FormControlLabel control={<Checkbox checked={showStopPoint} onClick={() => { resetMapPositions(); setShowStopPoint(!showStopPoint); getPositions(positionDatetime1, positionDatetime2, !showStopPoint); }} />} label="نمایش نقاط توقف"/>*/}
                    {/*    </MenuItem>*/}
                    {/*    <MenuItem className="item">*/}
                    {/*        <FormControlLabel control={<Checkbox checked={showDirectionSign} onClick={() => setShowDirectionSign(!showDirectionSign)}/>} label="نمایش جهت حرکت"/>*/}
                    {/*    </MenuItem>*/}
                    {/*    <MenuItem className="item">*/}
                    {/*        <div>میزان تراکم نقاط نمایش</div>*/}
                    {/*        <div className="tolerance-box">*/}
                    {/*            <ButtonGroup size="small" aria-label="Small button group">*/}
                    {/*                <Button color="info" variant={positionTolerance === 0.0004 ? "contained" : "outlined"} startIcon={positionTolerance === 0.0004 ? <CheckTwoToneIcon /> : null} onClick={() => handleTolerance(0.0004)}>کم</Button>*/}
                    {/*                <Button color="info" variant={positionTolerance === 0.00004 ? "contained" : "outlined"} startIcon={positionTolerance === 0.00004 ? <CheckTwoToneIcon /> : null} onClick={() => handleTolerance(0.00004)}>نرمال</Button>*/}
                    {/*                <Button color="info" variant={positionTolerance === 0.000004 ? "contained" : "outlined"} startIcon={positionTolerance === 0.000004 ? <CheckTwoToneIcon /> : null} onClick={() => handleTolerance(0.000004)}>زیاد</Button>*/}
                    {/*            </ButtonGroup>*/}
                    {/*            /!*<FormControlLabel control={<Checkbox checked={positionTolerance === 0} onClick={() => { resetMapPositions(); setPositionTolerance(0); getPositions(positionDatetime1, positionDatetime2, showStopPoint, 0); }}/>} label="0"/>*!/*/}
                    {/*            /!*<FormControlLabel control={<Checkbox checked={positionTolerance === 0.0004} onClick={() => { resetMapPositions(); setPositionTolerance(0.0004); getPositions(positionDatetime1, positionDatetime2, showStopPoint, 0.0004);}}/>} label="0.0004"/>*!/*/}
                    {/*            /!*<FormControlLabel control={<Checkbox checked={positionTolerance === 0.00004} onClick={() => { resetMapPositions(); setPositionTolerance(0.00004); getPositions(positionDatetime1, positionDatetime2, showStopPoint, 0.00004);}}/>} label="0.00004"/>*!/*/}
                    {/*            /!*<FormControlLabel control={<Checkbox checked={positionTolerance === 0.000004} onClick={() => { resetMapPositions(); setPositionTolerance(0.000004); getPositions(positionDatetime1, positionDatetime2, showStopPoint, 0.0000004);}}/>} label="0.000004"/>*!/*/}
                    {/*        </div>*/}
                    {/*    </MenuItem>*/}
                    {/*    <MenuItem className="item">*/}
                    {/*        <div className="max-speed-box">*/}
                    {/*            <TextField size="small" dir="ltr" label="حداکثر سرعت مجاز" variant="outlined" value={maxSpeed} onChange={(e) => setMaxSpeed(e.target.value)} />*/}
                    {/*            <Button variant="contained" color="primary" onClick={() => { resetMapPositions(); getPositions(positionDatetime1, positionDatetime2); }}>تایید</Button>*/}
                    {/*        </div>*/}
                    {/*    </MenuItem>*/}
                    {/*</Menu>*/}

                    <button type="button" className="btn-filter" onClick={handleOpenFilter}><RestoreTwoToneIcon /></button>
                    <Menu anchorEl={anchorElFilter} open={openFilter} onClose={handleCloseFilter} className="filter-menu-items">
                        <MenuItem className="item" onClick={() => handleFilterChange(15)}>15 دقیقه</MenuItem>
                        <MenuItem className="item" onClick={() => handleFilterChange(30)}>30 دقیقه</MenuItem>
                        <MenuItem className="item" onClick={() => handleFilterChange(60)}>یک ساعت</MenuItem>
                        <MenuItem className="item" onClick={() => handleFilterChange(120)}>2 ساعت</MenuItem>
                        <MenuItem className="item" onClick={() => handleFilterChange(24)}>24 ساعت</MenuItem>

                        <MenuItem className="item" onClick={() => handleFilterChange(1)}>امروز</MenuItem>
                        <MenuItem className="item" onClick={() => handleFilterChange(2)}>دیروز</MenuItem>
                        <MenuItem className="item" onClick={() => handleFilterChange(3)}>تاریخ و ساعت انتخابی</MenuItem>
                    </Menu>

                    {userState.isTracking ? null : <button type="button" className="btn-back" onClick={handleBack}><KeyboardBackspaceTwoToneIcon/></button>}
                </div>
            </header>

            {/* modal setting */}
            <Dialog open={openSetting}>
                <DialogContent className="dialog-setting">
                    <FormControlLabel control={<Checkbox checked={showStopPoint} onClick={() => { setShowStopPoint(!showStopPoint); }} />} label="نمایش نقاط توقف" />

                    <FormControlLabel control={<Checkbox checked={showDirectionSign} onClick={() => setShowDirectionSign(!showDirectionSign)} />} label="نمایش جهت حرکت" />

                    <div className="tolerance-box">
                        <div>میزان تراکم نقاط نمایش</div>
                        <ButtonGroup size="small" aria-label="Small button group">
                            <Button color="info" variant={positionTolerance === 0.0004 ? "contained" : "outlined"} startIcon={positionTolerance === 0.0004 ? <CheckTwoToneIcon /> : null} onClick={() => setPositionTolerance(0.0004)}>کم</Button>
                            <Button color="info" variant={positionTolerance === 0.00004 ? "contained" : "outlined"} startIcon={positionTolerance === 0.00004 ? <CheckTwoToneIcon /> : null} onClick={() => setPositionTolerance(0.00004)}>نرمال</Button>
                            <Button color="info" variant={positionTolerance === 0.000004 ? "contained" : "outlined"} startIcon={positionTolerance === 0.000004 ? <CheckTwoToneIcon /> : null} onClick={() => setPositionTolerance(0.000004)}>زیاد</Button>
                        </ButtonGroup>
                    </div>

                    <div className="max-speed-box">
                        <div>حداکثر سرعت مجاز</div>
                        <TextField size="small" dir="ltr" label="" variant="outlined" value={maxSpeed} onChange={(e) => setMaxSpeed(e.target.value)} />
                    </div>
                </DialogContent>

                <DialogActions>
                    <Button size="medium" variant="contained" color="success" onClick={handleCloseSetting}>ثبت</Button>
                </DialogActions>
            </Dialog>

            {/* map */}
            <MapContainer className="map" center={mapCenterPosition} zoom={18} scrollWheelZoom={false}>
                <TileLayer url={mapLayer} />

                {/* current position */}
                {
                    currentPosition != null && currentPosition.length > 0 ?
                        currentPosition.map
                        (
                            (item: any, index: number) =>
                            {
                                return <>
                                    {(index < (currentPosition.length - 1)) ? <Polyline key={"polp" + index} pathOptions={{color: 'blue', weight: 3, dashArray: '20, 6', lineCap: 'square'}} positions={[[currentPosition[index].latitude, currentPosition[index].longitude], [currentPosition[index + 1].latitude, currentPosition[index + 1].longitude]]} /> : null}

                                    {
                                        index === currentPosition.length - 1 ?
                                            <Marker key={"mark" + index} position={{lat: item.latitude, lng: item.longitude}} icon={iconDirectionCar[Math.round(item.course)]}>
                                                <Popup className="car-popup">{carInformation(item)}</Popup>
                                            </Marker>
                                            :
                                            null
                                    }
                                </>
                            }
                        )
                        :
                        null
                }

                {/* route positions & marker */}
                {
                    /*routePositions != null && routePositions.length > 0 && (routePositionsPlay == null || routePositionsPlay.length === 0) ?*/
                    routePositions != null && routePositions.length > 0 ?
                        routePositions.map
                        (
                            (item:any, index:number) =>
                            {
                                return<>
                                    {
                                        (index < (routePositions.length - 1)) ?
                                            <Polyline key={"pol" + index} pathOptions={{ color: helpers.initSpeed(routePositions[index].speed) > parseInt(maxSpeed) ? 'red' : 'green', weight: 3, dashArray: '20, 6', lineCap: 'square' }} positions={[[routePositions[index].latitude, routePositions[index].longitude], [routePositions[index + 1].latitude, routePositions[index + 1].longitude]]} />
                                        :
                                            null
                                    }

                                    <Marker key={"mark" + index} position={{lat: item.latitude, lng: item.longitude}} icon={(index === 0 || index >= routePositions.length - 1) ? iconDirectionCar[Math.round(item.course)] : (showDirectionSign ? iconDirectionSign[Math.round(item.course)] : iconPoint)}>
                                        <Popup className="car-popup">{carInformation(item)}</Popup>

                                        {
                                            index === 0 ?
                                                <Tooltip direction="bottom" opacity={1} permanent className="car-popup-start">شروع</Tooltip>
                                                :
                                                (
                                                    index >= routePositions.length - 1 ?
                                                        <Tooltip direction="bottom" opacity={1} permanent className="car-popup-end">پایان</Tooltip>
                                                        :
                                                        null
                                                )
                                        }
                                    </Marker>
                                </>
                            }
                        )
                        :
                        null
                }

                {
                    routePositionsStop != null && routePositionsStop.length > 0 ?
                        routePositionsStop.map
                        (
                            (item:any, index:number) =>
                            {
                                return<>
                                    <Marker key={"stop-marker-" + index} position={{lat: item.latitude, lng: item.longitude}} icon={iconStopMarker}>
                                        <Popup className="car-stop-popup">
                                            <div className="car-stop-popup-item"><span className="title">مدت زمان توقف</span><span className="value">{item.stopTime} دقیقه</span></div>
                                            <div className="car-stop-popup-item"><span className="title">شروع توقف</span><span className="value">{item.timeStart}</span></div>
                                            <div className="car-stop-popup-item"><span className="title">پایان توقف</span><span className="value">{item.timeEnd}</span></div>
                                        </Popup>
                                    </Marker>
                                </>
                            }) :
                        null
                }

                {/* route positions play */}
                {
                    routePositionsPlay != null && routePositionsPlay.length > 1 ?
                        routePositionsPlay.map
                        (
                            (item:any, index:number) =>
                            {
                                return<>
                                    {
                                        (index < (routePositionsPlay.length - 1)) ?
                                            <Polyline key={"polp" + index} pathOptions={{ color: 'blue', weight: 3, dashArray: '20, 6', lineCap: 'square' }} positions={[[routePositionsPlay[index].latitude, routePositionsPlay[index].longitude], [routePositionsPlay[index + 1].latitude, routePositionsPlay[index + 1].longitude]]} />
                                            :
                                            null
                                    }

                                    {
                                        index >= routePositionsPlay.length - 1 ?
                                            <Marker eventHandlers={{ add: handleOpenPopup, popupclose: handleHidePopup, popupopen: handleShowPopup }} position={{lat: item.latitude, lng: item.longitude}} icon={iconDirectionCar[Math.round(item.course)]}><Popup className="car-popup">{carInformation(item)}</Popup></Marker>
                                            :
                                            null
                                    }
                                </>
                            }
                        )
                        :
                        null
                }

                <FlyMapTo position={mapCenterPosition}/>
            </MapContainer>

            {/* play position information */}
            {
                routePositionsPlay != null && routePositionsPlay.length > 1 ?
                    <div className="car-information">{carInformation(routePositionsPlay[routePositionsPlay.length - 1])}</div>
                    :
                    null
            }

            {/* play position information */}
            {
                routePositions != null && routePositions.length > 1 ?
                    <div className="total-distance"><span className="title">مسافت طی شده</span><span className="value">{totalDistance.toFixed(2)} km</span></div>
                    :
                    null
            }

            {/* map slider */}
            {
                routePositions != null && routePositions.length > 1 && isPlay ?
                    <Slider value={routePositionsPlayIndex} min={0} max={routePositions.length} aria-label="Default" valueLabelDisplay="auto" className="map-slider" onChangeCommitted={handleMapSlideChange}/>
                    :
                    null
            }

            {/* btn play - pause */}
            {
                routePositions != null && routePositions.length > 1 ?
                    <div className="btn-play-pause">
                        {
                            isPlay ?
                                <button className="btn btn-pause" onClick={handlePause}><PauseCircleIcon className="icon"/></button>
                                :
                                <button className="btn btn-play" onClick={() => handlePlay()}><PlayCircleIcon className="icon"/></button>
                        }
                    </div>
                    :
                    null
            }

            {/* modal filter date */}
            <Dialog open={dialogFilterDateIsOpen} onClose={handleDialogFilterDateClose}>
                <DialogContent className="dialog-filter-date">
                    <div className="row">
                        <MobileDatePicker localeText={{ okButtonLabel: 'تایید' }} label="از تاریخ" onChange={(e) => { if(e != null) setFilterDate1(e.toString()); }} />
                        <MobileTimePicker localeText={{ okButtonLabel: 'تایید' }} ampm={false} label="از ساعت" onChange={(e) => { if(e != null) setFilterTime1(e.toString()); }} />
                    </div>

                    <div className="row">
                        <MobileDatePicker localeText={{ okButtonLabel: 'تایید' }} label="تا تاریخ" onChange={(e) => { if(e != null) setFilterDate2(e.toString()); }} />
                        <MobileTimePicker localeText={{ okButtonLabel: 'تایید' }} ampm={false} label="تا ساعت" onChange={(e) => { if(e != null) setFilterTime2(e.toString()); }} />
                    </div>
                </DialogContent>

                <DialogActions>
                    <Button size="medium" variant="outlined" onClick={handleDialogFilterDateClose}>لغو</Button>
                    <Button size="medium" variant="contained" color="success" onClick={handleDialogFilterDate}>اعمال فیلتر</Button>
                </DialogActions>
            </Dialog>

            {/* loading */}
            {isLoading ? <LoadingOver/> : null}
        </div>
    );
}

export default Index;

//********************************************************** map center

function FlyMapTo(props:{position: any})
{
    const map = useMap()

    useEffect
    (
        () =>
        {
            map.flyTo(props.position);
        },
        [map, props.position]
    );

    return null;
}

